import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import Login from "../auth/login/login";
import PublicFeeStructure from "../PublicFeeStructure";
import Register from "../auth/register/register";
import TwoStepVerification from "../auth/twoStepVerification/twoStepVerification";
import EmailVerification from "../auth/emailVerification/emailVerification";
import ResetPassword from "../auth/resetPassword/resetPassword";
import ForgotPassword from "../auth/forgotPassword/forgotPassword";
import Login2 from "../auth/login/login-2";
import Login3 from "../auth/login/login-3";
import ResetPassword2 from "../auth/resetPassword/resetPassword-2";
import ResetPassword3 from "../auth/resetPassword/resetPassword-3";
import TwoStepVerification2 from "../auth/twoStepVerification/twoStepVerification-2";
import TwoStepVerification3 from "../auth/twoStepVerification/twoStepVerification-3";
import Register2 from "../auth/register/register-2";
import Register3 from "../auth/register/register-3";
import ForgotPassword2 from "../auth/forgotPassword/forgotPassword-2";
import ForgotPassword3 from "../auth/forgotPassword/forgotPassword-3";
import ResetPasswordSuccess from "../auth/resetPasswordSuccess/resetPasswordSuccess";
import ResetPasswordSuccess2 from "../auth/resetPasswordSuccess/resetPasswordSuccess-2";
import ResetPasswordSuccess3 from "../auth/resetPasswordSuccess/resetPasswordSuccess-3";
// import Events from "../announcements/events";
import LockScreen from "../auth/lockScreen";
import EmailVerification2 from "../auth/emailVerification/emailVerification-2";
import EmailVerification3 from "../auth/emailVerification/emailVerification-3";
import CreateEnquiry from "../CreateEnquiry";
import CreateRegistration from "../CreateRegistration";
import Home from "../index";
import Myenquiry from "../myenquiry";
import Myregistration from "../myregistration";
import Examschedule from "../examschedule";
import Notification from "../notification/Notification";
import ModuleWiseNotification from "../notification/ModuleWiseNotification";
import Entranceresult from "../entranceresult";
import ApplyEntranceExam from "../ApplyEntranceExam";

import Header from "../Header";
import Payment from "../Payment";
import SpecialDocument from "../SpecialDocument";
import Chat from "../Chat";
import ApplyRescheduleExam from "../ApplyReschedule";
import ApplyLeave from "../ApplyLeave";
import Visitor from "../Visitor";
import UpdateDetails from "../UpdateDetails";
import Feedback from "../Efeedback";
import SchoolRules from "../SchoolRules";
import SchoolInfo from "../SchoolInfo";
import SyllabusPage from "../Syllabus";

import NoticePage from "../Notice";
import NewsLetterPage from "../NewsLetter";
import Canteen from "../Canteen";
import Cocirricular from "../Cocirricular";
import Event from "../Event";
import StudentDocumentRequest from "../StudentDocumentRequest";
import UserObservation from "../UserObservation";
import TimeTablePage from "../TimeTablePage";
import Homework from "../Homework";
import Transport from "../Transport";
import OrderHistory from "../CanteenHistory";
import StudentInfoMonthly from "../StudentInfoMonthly";
import ExitPass from "../ExitPass";
import TransportDetails from "../TransportDetails";
import TransportNavigator from "../TransportNavigator";
import MedicalInfo from "../MedicalInfo";
import Information from "../Information";
import StudentExamination from "../StudentExamination";
import SchoolCommunications from "../SchoolCommunications";
import Food from "../Food";
import Attendance from "../Attendance";
import AttendanceDaily from "../AttendanceDaily";
import AttendanceMonthly from "../AttendanceMonthly";
import AttendanceTransport from "../AttendanceTransport";
import AddVisitor from "../AddVisitor";
import Submenu from "../Submenu";
import StudentGatePass from "../StudentGatePass";
import StudentAddGatePass from "../StudentAddGatePass";
import StudentUpdateGatePass from "../StudentUpdateGatePass";
import ExamInterview from "../ExamInterview";
import ExamReTest from "../ExamReTest";
import UpdateRegistration from "../UpdateRegistration";
import DocumentDownload from "../DocumentDownload";
import StudentProfileView from "../StudentProfileView";
import PaymentSuccess from "../PaymentSuccess";
import RegistrationForm from "../RegistrationForm";
import AdmissionFees from "../AdmissionFees";
import AccountSwitch from "../AccountSwitch/AccountSwitch";
import PayUFailure from "../auth/PayuPaymnt/PayUFailure";
import PayUPayment from "../auth/PayuPaymnt/PayUPayment";
import PayUSuccess from "../auth/PayuPaymnt/PayUSuccess";
import AdmissionForm from "../AdmissionForm";
import TransportInfo from "../TransportInfo/TransportInfo";

import FeeCollection from "../FeeCollection";
import FeeCycles from "../FeeCycles";
import FeeHistory from "../FeeHistory";
import ExamTimetable from "../ExamTimetable";
import Exam from "../Exam";
import ExamPapers from "../ExamPapers";
import MarksheetView from "../MarksheetView";
import UpdateHistory from "../UpdateHistory";
import AttendanceTransportHistory from "../AttendanceTransportHistory";
import StudentLeave from "../StudentLeave";
import EfeedbackChat from "../EfeedbackChat";
import Timetable from "../Timetable";
import LibraryBooks from "../LibraryBooks";
import LibraryIssuedBook from "../LibraryIssuedBook";
import ChapterTest from "../ChapterTest";
import ChapterResult from "../ChapterResult";
import ChapterDetails from "../ChapterDetails";
import ResendPasswordHistory from "../ResendPasswordHistory";
import AdmissionLogin from "../auth/login/AdmissionLogin";
import AddEfeedback from "../AddEfeedback";
import FeeDetailNew from "../FeeDetailNew";
import NormalMarksheet from "../NormalMarksheet";
import Maintenance from "../Maintenance";
import FeeAccuracyReport from "../FeeAccuracyReport";
// import Exam from "../exam";
// import Exam from "../exam"
const routes = all_routes;

export const publicRoutes = [
  // {
  //   path: "/",
  //   name: "Root",
  //   element: <Navigate to="/login" />,
  //   route: Route,
  // },

  {
    path: routes.index,
    element: <Home />,
  },
  {
    path: routes.Maintenance,
    element: <Maintenance />,
  },

  {
    path: routes.index,
    element: <PayUFailure />,
  },
  {
    path: routes.index,
    element: <PayUPayment />,
  },
  {
    path: routes.index,
    element: <PayUSuccess />,
  },
  {
    path: routes.createenquiry,
    element: <CreateEnquiry />,
    route: Route,
  },

  {
    path: "/enquiry",
    element: <Myenquiry />,
    route: Route,
  },
  {
    path: "/registration",
    element: <Myregistration />,
    route: Route,
  },
  {
    path: "/examschedule",
    element: <Examschedule />,
    route: Route,
  },
  {
    path: "/examinterview",
    element: <ExamInterview />,
    route: Route,
  },
  {
    path: "/createregistration",
    element: <CreateRegistration />,
    route: Route,
  },
  {
    path: "/paymentsuccess",
    element: <PaymentSuccess />,
    route: Route,
  },
  {
    path: "/registrationform",
    element: <RegistrationForm />,
    route: Route,
  },
  {
    path: "/admissionform",
    element: <AdmissionForm />,
    route: Route,
  },
  {
    path: "/transportinfo",
    element: <TransportInfo />,
    route: Route,
  },
  {
    path: "/accountswitch",
    element: <AccountSwitch />,
    route: Route,
  },

  {
    path: "/admissionfees",
    element: <AdmissionFees />,
    route: Route,
  },
  {
    path: "/attendancetransporthistory",
    element: <AttendanceTransportHistory />,
    route: Route,
  },

  {
    path: "/updateregistration",
    element: <UpdateRegistration />,
    route: Route,
  },
  {
    path: "/documentdownload",
    element: <DocumentDownload />,
    route: Route,
  },
  {
    path: "/studentprofileview",
    element: <StudentProfileView />,
    route: Route,
  },
  {
    path: "/notification",
    element: <Notification />,
    route: Route,
  },
  {
    path: "/notification/ModuleWiseNotification/:moduleId",
    element: <ModuleWiseNotification />,
    route: Route,
  },
  {
    path: "/entranceresult",
    element: <Entranceresult />,
    route: Route,
  },
  {
    path: "/applyentrancere/:id",
    element: <ApplyEntranceExam />,
    route: Route,
  },
  {
    path: "/applyreschedule/:bookingId/:examId",
    element: <ApplyRescheduleExam />,
    route: Route,
  },
  {
    path: "/AapproveStudentInfo",
    element: <UpdateDetails />,
    route: Route,
  },
  {
    path: "/update-history",
    element: <UpdateHistory />,
    route: Route,
  },

  {
    path: "/efeedback",
    element: <Feedback />,
    route: Route,
  },
  {
    path: "/addefeedback",
    element: <AddEfeedback />,
    route: Route,
  },
  {
    path: "/MedicalInfo",
    element: <MedicalInfo />,
    route: Route,
  },
  {
    path: "/schoolrule",
    element: <SchoolInfo />,
    route: Route,
  },
  {
    path: "/school-info",
    element: <SchoolInfo />,
    route: Route,
  },
  {
    path: "/schoolinfo",
    element: <SchoolInfo />,
    route: Route,
  },

  {
    path: "/syllabus",
    element: <SyllabusPage />,
    route: Route,
  },
  {
    path: "/SchoolNotice",
    element: <NoticePage />,
    route: Route,
  },
  {
    path: "/ResendPasswordHistory",
    element: <ResendPasswordHistory />,
    route: Route,
  },
  {
    path: "/information",
    element: <Information />,
    route: Route,
  },
  {
    path: "/studentexamination",
    element: <StudentExamination />,
    route: Route,
  },
  {
    path: "/schoolcommunications",
    element: <SchoolCommunications />,
    route: Route,
  },
  {
    path: "/food",
    element: <Food />,
    route: Route,
  },

  {
    path: "/NewsLetter",
    element: <NewsLetterPage />,
    route: Route,
  },
  {
    path: "/Canteen",
    element: <Canteen />,
    route: Route,
  },
  {
    path: "/Cocurricular",
    element: <Cocirricular />,
    route: Route,
  },
  {
    path: "/efeedbackchat",
    element: <EfeedbackChat />,
    route: Route,
  },
  {
    path: "/libraryBooks",
    element: <LibraryBooks />,
    route: Route,
  },
  {
    path: "/events",
    element: <Event />,
    route: Route,
  },
  {
    path: "/StudentDocumentRequest",
    element: <StudentDocumentRequest />,
    route: Route,
  },
  {
    path: "/HomeWork",
    element: <Homework />,
    route: Route,
  },
  {
    path: "/orderhistory",
    element: <OrderHistory />,
    route: Route,
  },
  {
    path: "/transport",
    element: <Transport />,
    route: Route,
  },
  {
    path: "/transportdetails",
    element: <TransportDetails />,
    route: Route,
  },
  {
    path: "/montylyInformation",
    element: <StudentInfoMonthly />,
    route: Route,
  },

  {
    path: "/attendance",
    element: <Attendance />,
    route: Route,
  },
  {
    path: "/attendancedaily",
    element: <AttendanceDaily />,
    route: Route,
  },
  {
    path: "/attendancemonthly",
    element: <AttendanceMonthly />,
    route: Route,
  },
  {
    path: "/attendancetransport",
    element: <AttendanceTransport />,
    route: Route,
  },

  {
    path: "/transportdetails",
    element: <TransportDetails />,
    route: Route,
  },
  {
    path: "/transportnavigator",
    element: <TransportNavigator />,
    route: Route,
  },
  {
    path: "/userObservation",
    element: <UserObservation />,
    route: Route,
  },
  {
    path: "/payment/:registrationId",
    element: <Payment />,
    route: Route,
  },
  {
    path: "/specialdocument",
    element: <SpecialDocument />,
    route: Route,
  },
  {
    path: "/applyleave",
    element: <ApplyLeave />,
    route: Route,
  },
  {
    path: "/visitor",
    element: <Visitor />,
    route: Route,
  },
  {
    path: "/addvisitor",
    element: <AddVisitor />,
    route: Route,
  },
  {
    path: "/StudentGatePass",
    element: <StudentGatePass />,
    route: Route,
  },
  {
    path: "/StudentAddGatePass",
    element: <StudentAddGatePass />,
    route: Route,
  },
  {
    path: "/StudentUpdateGatePass/:id",
    element: <StudentUpdateGatePass />,
    route: Route,
  },
  {
    path: "/chat",
    element: <Chat />,
    route: Route,
  },
  {
    path: "/FeeCycles",
    element: <FeeCycles />,
    route: Route,
  },
  {
    path: "/FeeAccuracyReport",
    element: <FeeAccuracyReport />,
    route: Route,
  },
  {
    path: "/FeeCollection",
    element: <FeeCollection />,
    route: Route,
  },
  {
    path: "/FeeDetailNew",
    element: <FeeDetailNew />,
    route: Route,
  },
  {
    path: "/FeeHistory",
    element: <FeeHistory />,
    route: Route,
  },
  {
    path: "/ExamTimetable",
    element: <ExamTimetable />,
    route: Route,
  },
  {
    path: "/timetable",
    element: <Timetable />,
    route: Route,
  },
  {
    path: "/Exam",
    element: <Exam />,
    route: Route,
  },
  {
    path: "/chaptertest",
    element: <ChapterTest />,
    route: Route,
  },
  {
    path: "/chapterresult",
    element: <ChapterResult />,
    route: Route,
  },
  {
    path: "/chapterdetails",
    element: <ChapterDetails />,
    route: Route,
  },
  {
    path: "/exam-papers",
    element: <ExamPapers />,
    route: Route,
  },
  {
    path: "/MarksheetView",
    element: <MarksheetView />,
    route: Route,
  },
  {
    path: "/NormalMarksheet",
    element: <NormalMarksheet />,
    route: Route,
  },

  // {
  //   path: routes.chat,
  //   element: <Chat />,
  //   route: Route,
  // },

  // Peoples Module

  // {
  //   path: routes.studentLeaves,
  //   element: <StudentLeaves />,
  // },
  {
    path: routes.studentLeaves,
    element: <StudentLeave />,
  },

  {
    path: routes.examretest,
    element: <ExamReTest />,
  },

  // {
  //   path: routes.libraryBooks,
  //   element: <Books />,
  // },

  {
    path: routes.libraryissuedbook,
    element: <LibraryIssuedBook />,
  },
];

export const authRoutes = [
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.admissionlogin,
    element: <AdmissionLogin />,
    route: Route,
  },
  {
    path: routes.publicFeeStucture,
    element: <PublicFeeStructure />,
    route: Route,
  },
  {
    path: routes.login2,
    element: <Login2 />,
    route: Route,
  },
  {
    path: routes.login3,
    element: <Login3 />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.twoStepVerification,
    element: <TwoStepVerification />,
    route: Route,
  },
  {
    path: routes.twoStepVerification2,
    element: <TwoStepVerification2 />,
    route: Route,
  },
  {
    path: routes.twoStepVerification3,
    element: <TwoStepVerification3 />,
    route: Route,
  },
  {
    path: routes.emailVerification,
    element: <EmailVerification />,
    route: Route,
  },
  {
    path: routes.emailVerification2,
    element: <EmailVerification2 />,
    route: Route,
  },
  {
    path: routes.emailVerification3,
    element: <EmailVerification3 />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.register2,
    element: <Register2 />,
    route: Route,
  },

  {
    path: routes.register3,
    element: <Register3 />,
    route: Route,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.resetPassword2,
    element: <ResetPassword2 />,
    route: Route,
  },
  {
    path: routes.resetPassword3,
    element: <ResetPassword3 />,
    route: Route,
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes.forgotPassword2,
    element: <ForgotPassword2 />,
    route: Route,
  },
  {
    path: routes.forgotPassword3,
    element: <ForgotPassword3 />,
    route: Route,
  },
  {
    path: routes.exitpass,
    element: <ExitPass />,
    route: Route,
  },
  
  {
    path: routes.submenu,
    element: <Submenu />,
    route: Route,
  },
  {
    path: routes.lockScreen,
    element: <LockScreen />,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <ResetPasswordSuccess />,
  },
  {
    path: routes.resetPasswordSuccess2,
    element: <ResetPasswordSuccess2 />,
  },
  {
    path: routes.resetPasswordSuccess3,
    element: <ResetPasswordSuccess3 />,
  },
];
